// extracted by mini-css-extract-plugin
export default {"auth":"YouTubeAuthControl_auth__KK-DG","button":"YouTubeAuthControl_button__YgCFY","account":"YouTubeAuthControl_account__iFOQ1"};